import { useState } from 'react'
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap'
import './accordion.css'
import styles from './Jeemocktest.module.css'
import JeeBenchmarking from '../../assets/benchmaking_testseries.png'
import JeeSimulation from '../../assets/simulation_testseries.png'
import JeeAnalytics from '../../assets/analytics_testseries.png'
import JeeBenchmarkingM from '../../assets/benchmaking_testseriesM.png'
import JeeSimulationM from '../../assets/simulation_testseriesM.png'
import JeeAnalyticsM from '../../assets/analytics_testseriesM.png'
const JeeMockTestSeries = () => {
    const [open, setOpen] = useState('1');
    const [selectedImage, setSelectedImage] = useState(JeeBenchmarking);  // Default image
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
        switch (id) {
            case "1":
                setSelectedImage(JeeBenchmarking);
                break;
            case "2":
                setSelectedImage(JeeSimulation);
                break;
            case "3":
                setSelectedImage(JeeAnalytics);
                break;
            default:
                break;
        }
    };
 
    return (
        <div className={`${styles.jee_mock_series_wrapper}`}>
            <div className={`container ${styles.jee_ms} p-0`}>
                <h3>Why Invictus open test is a must</h3>
                <div className={`${styles.jeets_accordsection}`}>
                <div className={`${styles.jeets_box}`}>
                    <Accordion open={open} toggle={toggle} flush>
                        <AccordionItem className={`${styles.accordion_jeets} item`}>
                            <AccordionHeader targetId="1" className={`bg-grey-9 border-0 ${styles.accor_header}`}>True SWOT analysis</AccordionHeader>
                            <AccordionBody accordionId="1" className={`${styles.accor_jeebody}`}>
                                A clear reflection of your true strengths and weaknesses
                                <img src={JeeBenchmarkingM} alt="test series" className={`${styles.m_block} img-fluid`}/>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className={`${styles.accordion_jeets} item`}>
                            <AccordionHeader targetId="2" className={`bg-grey-9 border-0 ${styles.accor_header}`}>Real Exam Pressure</AccordionHeader>
                            <AccordionBody accordionId="2" className={`${styles.accor_jeebody}`}>
                            Experience the same time constraints and testing environment as the actual JEE examination.
                            <img src={JeeSimulationM} alt="test series" className={`${styles.m_block} img-fluid`}/>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className={`${styles.accordion_jeets} item`}>
                            <AccordionHeader targetId="3" className={`bg-grey-9 border-0 ${styles.accor_header}`}>Built by Rank Makers, Not Content Creators</AccordionHeader>
                            <AccordionBody accordionId="3" className={`${styles.accor_jeebody}`}>
                              Every test is created by mentors who’ve consistently delivered top 500 AIRs and not by anonymous content teams. That’s why our questions feel tougher but teach deeper.
                                <img src={JeeAnalyticsM} alt="Test series" className={`${styles.m_block} img-fluid`}/>
                            </AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
                <div className={`${styles.jeets_box}`}>
                     <img src={selectedImage} alt="test series" className={`${styles.d_block} img-fluid`}/>
                </div>
                </div>
            </div>
        </div>
    )
}

export default JeeMockTestSeries